import { mapActions } from "vuex";
import moment from "moment";
import statusFilter from '@/components/filter'
import draggable from 'vuedraggable'
import _ from "lodash";
export default {
    name: "orderList",
    components: {
        draggable,
        statusFilter
    },
    data() {
        return {
            permissions: {
				cancelEnquiry: false, //取消询价
                enquiryLook: false    //查询
			},
            outerOrderId: null,
            quotedPriceId: null,
            enqId: null,
            quoteList: [],
            selectOneVisible: false,
            isDisabled: true,
            placeLoading: false,
            srcColumeList: ['长期订单号', '客户订单号', '时间'],
            srcColumeList_checked: ['长期订单号', '客户订单号', '时间'],
            statusObj: { /* 订单详情状态 */
                status: true,
                status1: false,
                status2: false,
                status3: false,
            },
            longTab: 'order',
            weekDateList: [{ week: '周一', date: '-' }, { week: '周二', date: '-' }, { week: '周三', date: '-' }, { week: '周四', date: '-' }, { week: '周五', date: '-' }, { week: '周六', date: '-' }, { week: '周日', date: '-' },],
            filterList1: [
                { label: "待竞价", value: 501 },
                { label: "竞价中", value: 502 },
                { label: "待确认定标", value: 503 },
            ],
            filterList2: [
                { label: "未指派人车", value: 1 },
                { label: "已指派人车", value: 2 },
            ],
            filterList3: [
                { label: "未确认收货", value: 1 },
                { label: "已确认收货", value: 2 },
            ],
            filterList4: [
                { label: "货主取消", value: 506 },
                { label: "已流标", value: 505 },
            ],
            isDataFromSessionStrorage: false,
            dataOwner: [],
            cancelLoading: false,
            monitors: [],
            etcFenceDistanceMap: {},
            bidContacts: '',
            cdTmIns: null,
            show: {
                OrderList_Export: false,
                OrderList_Cancel: false,
                OrderUpdate: false,
                OrderList_Ensure: false,
            },
            bidDay: 0,
            bidHour: 0,
            bidMinute: 0,
            bidSecond: 0,
            bid_orderId: null,
            isTaskConflict: 0,
            bargainPrice: null,
            expectPrice: null,
            floatingRatio: 0,
            page: 'orderList',
            checkpictureVisible: false,
            configColsVisible: false,/*  自定义页面配置，自定义列 */
            loading: false,
            loading_w: false,
            exportLoading: false,
            vehicleMap: [{
                "plVehicleType": "厢式",
                "plVehicleCode": "300",
                "grdVehicleCode": "002001"
            },
            {
                "plVehicleType": "平板",
                "plVehicleCode": "350",
                "grdVehicleCode": "002007"
            },
            {
                "plVehicleType": "高栏",
                "plVehicleCode": "450",
                "grdVehicleCode": "002024"
            },
            {
                "plVehicleType": "特种运输",
                "plVehicleCode": "600",
                "grdVehicleCode": "002025"
            },
            {
                "plVehicleType": "封闭式一体货车/客车",
                "plVehicleCode": "100",
                "grdVehicleCode": "002016"
            },
            {
                "plVehicleType": "冷藏车",
                "plVehicleCode": "900",
                "grdVehicleCode": "002013"
            }],
            SFMap: window.SFMap,
            mode: '1',
            form: {
                enquiryNo: null,
                srcCityName: null,
                createTm: [],
                state: null,

                pageNum: 1,
                pageSize: 10,
            },

            total: 0,
            total_w: 0,
            tabs: {
                activeName: 0,
                label0: '全部',
                label1: '询价中',
                label2: '待下单',
                label3: '处理中',
                label4: '已取消',
                label6: '已下单',
            },
            table: [],
            table_w: [],
            detail: {
                map: {
                    carNewestPosMarker: null,
                    mapIns: '',
                    polyline: '',
                    pointLayer: null,
                    planLayer: [],
                    carLayer: [],
                    phoneLayer: [],
                    truckMainCoordinate: [],
                    planGPS: false,
                    carGPS: false,
                    phoneGPS: false,
                    coordinates: [],
                    planCoordinates: [],
                    carCoordinates: [],
                    phoneCoordinates: [],
                },
                res: {},
                status: {
                    status: true,
                    status1: false,
                    status2: false,
                    status3: false,
                },
                order: {
                    title: '-'
                    , state: ''
                    , statusName: '待交易'
                    , orderId: ''
                    , planArriveTm: ''
                    , reachTm: ''
                    , totalPrice: ''
                    , needReceipt: ''
                    , needReceiptImg: ''
                    , needReceiptSrc: ''
                    , dataOwner: ''
                    , distance: ''
                    , runTm: ''
                    , cargoInfo: ''
                    , cargoWeight: ''
                    , cargoVolume: ''
                    , mode: ''
                    , carType: ''
                    , vehicleType: ''
                    , vehicleLength: ''
                    , comment: ''
                    , priceRule: ''
                    , price: ''
                    , passZones: []
                    , oplogList: []
                    , srcCity: ''
                    , vehicleSerial: ''
                    , taskId: ''
                    , biddingVO: {
                        biddingEndTm: null,
                        biddingStartTm: null,
                        dealState: null,
                        enterUserCount: null,
                        expectPrice: null,
                        floatPercentage: null,
                        joinUserCount: null,
                        lowestPrice: null,
                        totalPrice: null,
                    }
                    , deductionInfoResponses: []
                },
                table: [],
                logData: [],
            },
            orderDetailVisible: false,
            cancelVisible: false,
            bidVisible: false,
            progress: 0,
            cancelForm: {
                rules: {
                    cancelCause: [{ required: true, message: "请选择取消原因", trigger: "change" }]
                },
                id: '',
                outerOrderId: '',
                cancelCause: '',
                cancelComment: '',
            }
        }
    },
    methods: {
        ...mapActions([
            'getPlanOrderListApi',
            'getPlanOrderList_wApi',
            'planOrderExportApi',
            'getPlanOrderDetailApi',
            'relPlanOrderApi',/* 临时用车关联订单 */

            'cancelPlanOrderApi',
            'cancelOrderApi',
            'ensureOrderApi',
            'queryReceiptApi',
            'queryTrackApi',
            'queryBidDetailApi',
            'confirmBidApi',
            'initPlaceApi',

            'getOrderEnquiryListApi',
            'getOrderEnquiryDetailApi',
            'cancelOrderEnquiryApi',
            'confirmOrderEnquiryApi',
            'quotedPriceQueryListApi',
        ]),
        /* 自定义列 */
        syncColume() {

        },
        /* 周排班状态 0无1未开始2进行中3已完成4已取消5已终止 */
        geneColumnImg(status) {
            let html = '';
            let icon = ''
            if (status == 1) {
                icon = 'undo'
            } else if (status == 2) {
                icon = 'ing'
            } else if (status == 3) {
                icon = 'finish'
            } else if (status == 4) {
                icon = 'cancel'
            } else if (status == 5) {
                icon = 'zz'
            } else {
                icon = ''
            }
            html = `<span class="commonicon ${icon}"></span>`
            return html;
        },
        geneColumn(row, idx) {
            let key = null
            switch (idx) {
                case 0: key = 'monday'; break;
                case 1: key = 'tuesday'; break;
                case 2: key = 'wednesday'; break;
                case 3: key = 'thursday'; break;
                case 4: key = 'friday'; break;
                case 5: key = 'saturday'; break;
                case 6: key = 'weekday'; break;
            }
            return this.geneColumnImg(row[key])
        },


        longtabClick() { },
        resetSubStatus() { /* 重置子状态 */
            this.form.dealState = ''
            this.form.assignState = ''
            this.form.ensureState = ''
        },
        onSelectSubStatus(emitObj, formItem, indx) {
            this.tabs.activeName = indx
            this.resetSubStatus();
            this.form[formItem] = emitObj.value
            this.getOrderList()
        },
        mapFindCar(dispatchMode) {
            let res = '';
            switch (dispatchMode) {
                case 0: res = '指派用车'; break;
                case 1: res = '一口价找车'; break;
                case 2: res = '竞价找车'; break;
                default: res = ''; break;
            }
            return res;
        },
        calcCDTime() {
            let a = moment()
            // let b = moment(1624953600000)
            let b = moment(this.detail.res.expiryDate)
            let m = b.diff(a, 'seconds')
            if (this.cdTmIns) {
                clearInterval(this.cdTmIns)
                this.bidDay = 0
                this.bidHour = 0
                this.bidMinute = 0
                this.bidSecond = 0
            }
            if (m > 0) {

                this.cdTmIns = setInterval(() => {
                    let days = moment.duration(m, 'seconds').days()
                    let hours = moment.duration(m, 'seconds').hours()
                    let minutes = moment.duration(m, 'seconds').minutes()
                    let seconds = moment.duration(m, 'seconds').seconds()

                    if (hours < 10) {
                        hours = '0' + hours
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes
                    }
                    if (m == 0 || m < 0) {
                        clearInterval(this.cdTmIns)
                    }
                    this.bidDay = days
                    this.bidHour = hours
                    this.bidMinute = minutes
                    this.bidSecond = seconds
                    m--;
                }, 1000);
            } else {

            }
        },
        mapCreateType(type) {
            let createType = ''
            switch (type) {
                case "1": createType = '系统创建'; break;
                case "2": createType = '人工创建'; break;
                default: createType = '-'; break;
            }
            return createType
        },
        onHandBid(action) {
            this.confirmBidApi({ orderId: this.bid_orderId, operate: action }).then(res => {
                this.bidVisible = false
                if (action == 1) {
                    this.$message({
                        type: 'success',
                        message: '定标成功'
                    });
                } else {
                    this.$message({
                        type: 'success',
                        message: '已流标'
                    });
                }
                this.getOrderList();
            })
        },
        onConfirmBid(orderId) {
            this.queryBidDetailApi({ orderId: orderId }).then(res => {
                this.bid_orderId = orderId
                this.bidVisible = true
                this.bargainPrice = res.bargainPrice
                this.expectPrice = res.expectPrice
                this.floatingRatio = res.floatingRatio
                this.isTaskConflict = res.isTaskConflict
                if (res.carriageType == 1) {
                    this.bidContacts = res.driverName + ' / ' + res.driverPhone
                } else {
                    this.bidContacts = res.carrierName

                }
            })
        },
        onAlterOrder(orderId) {
            sessionStorage.setItem('alterOrderId', orderId)
            this.$router.push('/manage/Shipments')
        },
        geneDetails(row) {
            let desc = row.desc ? row.desc : '-'
            let comment = row.comment ? row.comment : '-'
            let emtpy = "&nbsp;&nbsp;&nbsp;"
            return desc + emtpy + comment
        },

        onCheckPicture() {
            if (this.detail.order.needReceiptSrc) {
                this.checkpictureVisible = true;
            }
        },
        queryReceipt() {
            let params = {
                orderId: this.detail.order.orderId,
                srcCity: this.detail.order.srcCity
            }
            this.queryReceiptApi(params).then(res => {
                let photo = res.photoPath
                if (photo) {
                    this.detail.order.needReceiptImg = '<img title="点击放大" src="' + photo + '">'
                    this.detail.order.needReceiptSrc = photo
                } else {
                    this.detail.order.needReceiptImg = '-'
                }

            }).catch(e => { })
        },
        addhtml(key, value) {
            if (null == value) {
                return "<p>" + key + "</p>";
            } else {
                return "<p>" + key + "<span>" + value + "</span></p>";
            }
        },
        tmFormat(v) {
            if (v) {
                return moment(new Date(v)).format("MM/DD HH:mm");
            }
            return '';
        },
        //始发点弹出提示
        startHtml(monitor, lnglat, etcfenceDistance) {
            if (monitor) {
                let starthtml = "<div class='mapPopupContent' >";
                starthtml += this.addhtml("计划靠车时间：", this.tmFormat(monitor.planReachTm));
                starthtml += this.addhtml("实际靠车时间：", this.tmFormat(monitor.actualSrcGisInTm));
                starthtml += this.addhtml("计划发出时间：", this.tmFormat(monitor.planDepartTm));
                starthtml += this.addhtml("实际发车时间：", this.tmFormat(monitor.actualDepartTm));
                starthtml += this.addhtml("电子围栏半径：", etcfenceDistance);
                starthtml += this.addhtml("经纬度：", lnglat);
                starthtml += "</div>";
                return starthtml;
            }
            return "";
        },
        //经停点 和 终点 弹出提示
        otherHtml(monitor, lnglat, etcfenceDistance) {
            if (monitor) {
                let starthtml = "<div class='mapPopupContent2' >";
                starthtml += this.addhtml("预计到车时间：", this.tmFormat(monitor.preArriveTm));
                starthtml += this.addhtml("计划到车时间：", this.tmFormat(monitor.planArriveTm));
                starthtml += this.addhtml("实际到车时间：", this.tmFormat(monitor.actualArriveTm));
                starthtml += this.addhtml("电子围栏半径：", etcfenceDistance);
                starthtml += this.addhtml("经纬度：", lnglat);
                starthtml += "</div>";
                return starthtml;
            }
            return "";
        },
        //地图弹出提示
        promptMap(map, startMarker, endMarker, startLongitude, endLongitude, vectorLayer, passMarker, passCoordinate) {
            //起点提示
            this.addInfoToMarker(startMarker, startLongitude, this.startHtml(this.monitors[0], startLongitude, this.etcFenceDistanceMap.src));
            //终点提示
            this.addInfoToMarker(endMarker, endLongitude, this.otherHtml(this.monitors[this.monitors.length - 1], endLongitude, this.etcFenceDistanceMap.dest));
            //经停点
            try {
                let passZoneDatas = JSON.parse(JSON.stringify(this.monitors.splice(1, this.monitors.length - 2)));
                if (passMarker.length > 0) {
                    for (let int = 0; int < passMarker.length; int++) {
                        let marker = passMarker[int];
                        let coor = passCoordinate[int];
                        let lnglat = [coor[0], coor[1]];
                        this.addInfoToMarker(marker, lnglat, this.otherHtml(passZoneDatas[int], lnglat, this.etcFenceDistanceMap[coor[0] + coor[1]]));
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        //绑定弹出事件
        addInfoToMarker(marker, lnglat, info) {
            let that = this;
            let popup = this.SFMap.popup();
            marker.on("click", function () {
                popup.setLatLng(lnglat).setContent(info).openOn(that.detail.map.mapIns);
            });
        },
        queryTrack() {
            this.monitors = [];
            this.etcFenceDistanceMap = {};
            let params = {
                taskId: this.detail.order.taskId,
                vehicleSerial: this.detail.order.vehicleSerial,
                trucksOnly: 1
            }
            this.queryTrackApi(params).then(res => {
                this.monitors = res.monitors;
                this.etcFenceDistanceMap = JSON.parse(res.etcFenceDistanceMap);
                //车辆实时位置显示
                this.carPosShow(this.latlngSingleConvert(JSON.parse(res.carNewestPos)), false);
                //规划GPS
                let newarr0 = []
                if (res.mainCoordinate) {
                    let arr0 = JSON.parse(res.mainCoordinate)
                    arr0.forEach(item => {
                        newarr0.push([item[1], item[0]])
                    })
                }
                //车载GPS
                let newarr1 = []
                if (res.carLatLng && res.carLatLng.result) {
                    let arr1 = JSON.parse(res.carLatLng.result)
                    arr1.forEach(item => {
                        newarr1.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                    })
                }
                //手机GPS
                let newarr2 = []
                if (res.phoneLatLng && res.phoneLatLng.result) {
                    let arr2 = JSON.parse(res.phoneLatLng.result)
                    arr2.forEach(item => {
                        newarr2.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                    })
                }
                this.detail.map.planCoordinates = newarr0
                this.detail.map.carCoordinates = newarr1
                this.detail.map.phoneCoordinates = newarr2
                this.planChange(true);
                this.carChange(true);
                this.phoneChange(true);

                //经过点显示
                let passPoint = res.passCoordinateList
                if (passPoint.length > 0) {
                    passPoint.forEach(item => {
                        item.reverse()
                    })
                    this.drawPoints(passPoint);
                }

            }).catch(e => { })
        },
        onProgessChange(val) {
            let arr = this.detail.map.phoneCoordinates
            let i = parseInt(arr.length * val / 100)
            if (arr.length > 0) {
                this.showSlidePosition(arr[i]);
            }
        },
        showSlidePosition(coordinate) {
            let myIcon = this.SFMap.circleIcon({
                iconRadius: 100,
                backgroundColor: '#FF0033',
                circleRadius: 10,
                boxShadow: '0 0 30px 5px #FF0033',
                ripple: 2,
                rippleColor: '#FF0033',
            });
            let iconMarker = this.SFMap.marker(coordinate, {
                icon: myIcon
            });
            if (this.detail.map.vectorLayer) {
                this.detail.map.vectorLayer.clear();
            }
            this.detail.map.vectorLayer.addLayer(iconMarker);
        },
        mapVehicle(code) {
            let name = ''
            this.vehicleMap.forEach(item => {
                code == item.plVehicleCode && (name = item.plVehicleType)
            })
            return name
        },
        geneTmStr(m) {
            let days = moment.duration(m, 'minutes').days()
            let hours = moment.duration(m, 'minutes').hours()
            let minutes = moment.duration(m, 'minutes').minutes()
            return (days ? days : '-') + '天' + (hours ? hours : '-') + '时' + (minutes ? minutes : '-') + '分'
        },
        /* state 状态(1=待报价[询价中],2=待货主确认[待下单],3=待补充人车[处理中],4=已取消[已取消],5=待货主下单,6=已下单[已下单]) */
        mapState(state) {
            if (state == 0) return '全部';
            if (state == 1) return '询价中';
            if (state == 2) return '待下单';
            if (state == 3) return '处理中';
            if (state == 4) return '已取消';
            if (state == 5) return '待货主下单';
            if (state == 6) return '已下单';
            return '-'
        },
        clear(layer) {
            if (layer.length > 0) {
                layer[0].remove()
            }
        },
        planChange(val) {
            if (val) {
                this.clear(this.detail.map.planLayer)
                if (this.detail.map.planCoordinates.length > 0) {
                    this.draw(this.detail.map.planCoordinates, this.detail.map.planLayer, '#00bcd4', 10)
                }
            } else {
                this.clear(this.detail.map.planLayer)
            }
        },
        carChange(val) {
            if (val) {
                this.clear(this.detail.map.carLayer)
                if (this.detail.map.carCoordinates.length > 0) {
                    this.draw(this.detail.map.carCoordinates, this.detail.map.carLayer, '#1919fe')
                }
            } else {
                this.clear(this.detail.map.carLayer)
            }
        },
        phoneChange(val) {
            if (val) {
                this.clear(this.detail.map.phoneLayer)
                if (this.detail.map.phoneCoordinates.length > 0) {
                    this.draw(this.detail.map.phoneCoordinates, this.detail.map.phoneLayer, '#DC1E32', 7)
                }
            } else {
                this.clear(this.detail.map.phoneLayer)
            }
        },
        showStatus(status) {
            this.statusObj.status1 = false
            this.statusObj.status2 = false
            this.statusObj.status3 = false
            /*灰色默认 status 、红色status1 、 黑色status2  、  绿色status3    */
            if (status == 1 || status == 2 || status == 3) {
                this.statusObj.status1 = true
            } else if (status == 4) {

            } else if (status == 5 || status == 6) {
                this.statusObj.status2 = true
            }
        },
        onCheckDetail(id) {
            let params = { id: id }
            this.getOrderEnquiryDetailApi(params).then(res => {
                this.orderDetailVisible = true;
                this.detail.res = res
                this.detail.res.statusName = this.mapState(res.state)
                this.showStatus(res.state)
                if (res.state == 1) {
                    this.calcCDTime()
                }
            }).catch(e => { }).finally(() => {
                this.loading = false
            });
        },
        eCloseCancel() {
            this.$refs.cancelFormRef.resetFields();
        },
        onCancelOrder(row) {
            this.cancelForm.id = row.id;
            this.cancelForm.outerOrderId = row.outerOrderId;
            this.cancelVisible = true
        },
        onCancelConfirm() {
            let params = {
                id: this.cancelForm.id
                , outerOrderId: this.cancelForm.outerOrderId
                , cancelCause: this.cancelForm.cancelCause
                , cancelComment: this.cancelForm.cancelComment
            }
            this.$refs.cancelFormRef.validate((valid) => {
                if (valid) {
                    this.cancelLoading = true
                    this.cancelOrderEnquiryApi(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '取消成功'
                        });
                        this.cancelVisible = false
                        this.getOrderList();
                    }).catch(e => { }).finally(() => { this.cancelLoading = false });
                }
            })

        },
        onAcceptOrder(row) {
           
            this.selectOneVisible = true
            this.enqId = row.id
            this.outerOrderId = row.outerOrderId
            this.quotedPriceId = null/*  清空选择的ID */
            this.getQuotedPriceQueryList(row.id)
        },
        onOrderConfirm() {
            if (!this.isDisabled) return;
            this.isDisabled = false;
            if (!this.quotedPriceId) {
                this.$message({
                    type: 'warning',
                    message: '请选择一个报价'
                })
                this.isDisabled = true;
                return;
            }
            let params = {
                quotedPriceId: this.quotedPriceId,
                id: this.enqId
                , outerOrderId: this.outerOrderId
            }
            this.confirmOrderEnquiryApi(params).then(res => {
                this.$message({
                    type: 'success',
                    message: '确认成功'
                });
                this.getOrderList();
                this.selectOneVisible = false;
            }).catch(e => { })
            .finally(e => {                
                this.isDisabled = true;
            });
        },
        //显示当前车辆位置
        carPosShow(carNewestPosMap, isRequest) {
            if (this.detail.map.carNewestPosMarker) {
                this.detail.map.vectorLayer2.removeLayer(this.detail.map.carNewestPosMarker);
            }
            if (carNewestPosMap && carNewestPosMap.length > 0) {
                // 自定义图片图标
                let myIcon = this.SFMap.icon({
                    iconUrl: document.querySelector("#vehicleCurrentPosImg").src, // 图片路径
                    iconSize: [30, 30]
                });
                this.detail.map.carNewestPosMarker = this.SFMap.marker(carNewestPosMap, {
                    icon: myIcon
                });
                this.detail.map.vectorLayer2.addLayer(this.detail.map.carNewestPosMarker);
            }
        },
        latlngSingleConvert(latlng) {
            let latlngArray = []
            if (!latlng) {
                return latlngArray;
            }
            let zx = parseFloat(latlng[0]);
            let zy = parseFloat(latlng[1]);
            if (0.0 == zx && 0.0 == zy) {
                return latlngArray;
            }
            latlngArray.push(zy);
            latlngArray.push(zx);
            return latlngArray;
        },
        drawPoints(coordinates) {
            if (this.detail.map.pointLayer) {
                this.detail.map.pointLayer.clearLayers()
            }
            let startMarker = this.SFMap.marker(coordinates[0], { iconIndex: 'start' });
            let endMarker = this.SFMap.marker(coordinates[coordinates.length - 1], { iconIndex: 'end' });
            let passMarker = [];
            let pCoordinate = [];
            for (let i = 1; i < coordinates.length - 1; i++) {
                passMarker.push(this.SFMap.marker(coordinates[i], { iconIndex: 'pass' }));
                pCoordinate.push(coordinates[i]);
            }
            this.detail.map.pointLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns, features: [startMarker, ...passMarker, endMarker] });
            //弹出提示事件
            if (this.monitors.length >= 2) {
                this.promptMap(this.detail.map.mapIns, startMarker, endMarker, coordinates[0], coordinates[coordinates.length - 1], this.detail.map.vectorLayer, passMarker, pCoordinate);
            }
        },
        draw(coordinates, layer, color, width) {
            let c = color ? color : "#3388ff"
            let tplLayer = this.SFMap.polyline(coordinates, {
                map: this.detail.map.mapIns,
                color: c,
                opacity: 1,
                weight: (width ? width : 3),
                showSymbol: true,
                symbol: [{
                    type: 'arrow',
                    repeat: 50,
                    offset: 15,
                    rotate: false,
                    color: '#ffffff',
                    symbol: undefined
                }]
            });
            layer[0] = tplLayer
            this.detail.map.mapIns.fitBounds(tplLayer.getBounds());
        },

        eOpenDetail() {

        },
        initMap() {
            if (!this.detail.map.mapIns) {
                this.detail.map.mapIns = this.SFMap.map("map", {
                    center: [22.524729, 113.940159],
                    zoom: 12
                });
                this.detail.map.vectorLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });
                this.detail.map.vectorLayer2 = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });

            }
        },
        getComParams() {
            let params = Object.assign({}, this.form)
            return params
        },
        addState(params) {
            params.state = this.tabs.activeName
            if (this.tabs.activeName == 0) params.state = null;
            return params
        },
        getCounts(counts) {
            let nums = null;
            counts.forEach(i => {
                nums += i.orderCount
            });
            return nums;
        },
        async getQuotedPriceQueryList(id) {
            this.quotedPriceQueryListApi({ orderEnquiryId: id }).then(res => {
                let result = res.rows
                if (result.length == 1) {
                    this.quotedPriceId = result[0].id
                }
                this.quoteList = result;
            })
        },
        getOrderList() {
            this.table = []
            this.loading = true
            let params = this.getComParams();
            params = this.addState(params)
            params = this.addTm(params)
            this.getOrderEnquiryListApi(params).then(res => {
                let result = res.saasListResponses
                let total_counts = this.getCounts(res.counts)
                res.counts.push({ orderState: 0, orderCount: total_counts });
                res.counts.forEach(i => {
                    this.tabs['label' + i.orderState] = this.mapState(i.orderState) + '（' + i.orderCount + '）';
                    if (!params.state) params.status = 0
                    return i;
                });

                this.table = result.rows;
                this.total = result.totalCount;
            }).catch(e => { }).finally(() => {
                this.loading = false
            });
        },
        addTm(params) {
            if (params.createTm && params.createTm.length > 1) {
                params.createTmBegin = params.createTm[0]
                params.createTmEnd = params.createTm[1]
            } else {
                params.createTmBegin = null
                params.createTmEnd = null
            }
            return params
        },


        onExport() {
            this.exportLoading = true
            let params = this.getComParams();
            this.planOrderExportApi(params).then(res => {
                window.open(this.getHostUrl() + "/saas/orderCore/downLoadFile?objectName=" + res.filePath)
            }).catch(e => { }).finally(() => {
                this.exportLoading = false
            });
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        showDownload(url) {
            let downloadbtn = `<a href="${url}">点击下载导出的Excel文件</a>`
            this.$alert(downloadbtn, '下载', {
                confirmButtonText: '取消',
                customClass: 'css-alert',
                dangerouslyUseHTMLString: true,
                callback: action => { }
            });
        },
        onReset() {
            Object.assign(this.form, this.$options.data().form)
        },

        lineList(row) {
            return '<span class="point src"></span>' + row.srcAddr + '<br><span class="point dest"></span>' + row.destAddr
        },
        onSearch() {
            this.getOrderList();
        },
        onTabsClick(activeIndex) {
            /* this.resetSubStatus(); */
            this.tabs.activeName = activeIndex
            this.form.pageNum = 1;
            this.getOrderList()
        },
        onSizeChange() { },
        onCurrentChange(val) {
            this.form.pageNum = val;
            this.getOrderList()
        },

        initMapData() {
            this.detail.map.phoneGPS = true;
            this.detail.map.carGPS = true;
            this.detail.map.planGPS = true;
            this.progress = 0;
            if (this.detail.map.phoneLayer.length > 0) {
                this.clear(this.detail.map.phoneLayer)
            }
            if (this.detail.map.carLayer.length > 0) {
                this.clear(this.detail.map.carLayer)
            }
            if (this.detail.map.planLayer.length > 0) {
                this.clear(this.detail.map.planLayer)
            }
            if (this.detail.map.pointLayer) {
                this.detail.map.pointLayer.clearLayers()
            }

        },
        onToggleMode() {
            if (this.mode == '1') {
                this.mode = '2'
                this.initMapData();
                this.queryTrack();
                setTimeout(() => {
                    this.initMap()
                }, 0)
            } else {
                this.mode = '1'
            }
        },
        getParamsFromSession() {
            let params = JSON.parse(sessionStorage.getItem('orderListQueryParams'))
            if (params) {
                Object.assign(this.form, params) /* 回填切换tab保留查询条件 */
                this.isDataFromSessionStrorage = true
            }
        }
    },
    watch: {

    },
    created() {
        this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
        let orderId = sessionStorage.getItem('enquiryId')
        sessionStorage.removeItem('enquiryId');
        if (orderId) {
            this.onCheckDetail(orderId)
        }
    },
    mounted() {
        let startTm = moment().format('YYYY-MM-DD')
        let endTm = moment(startTm).subtract(30, 'day').format('YYYY-MM-DD')
        this.form.createTm = [endTm, startTm]
        this.getOrderList()
    }
}